import { Dot, type ColoredDotProps } from '../dot.component';

export const NeutralDot = ({ children, ...props }: ColoredDotProps) => (
  <Dot color='neutral' {...props}>
    <>{children}</>
  </Dot>
);
